import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsReportRoleScope, AnalyticsReportTypes } from '~/data/reports';

export const useReportTypeLabels = () => {
  const { t } = useTranslation();

  const { typeLabels, roleLabels } = useMemo(() => {
    const typeLabels: { [key in AnalyticsReportTypes]: string } = {
      [AnalyticsReportTypes.Company]: t('laCompany'),
      [AnalyticsReportTypes.Team]: t('laTeam'),
      [AnalyticsReportTypes.HR]: t('laHR'),
      [AnalyticsReportTypes.Employee]: t('laEmployee'),
      [AnalyticsReportTypes.Unit]: t('laUnit'),
      [AnalyticsReportTypes.LegalEntity]: t('laLegalEntity'),
    };

    const roleLabels: { [key in AnalyticsReportRoleScope]: string } = {
      [AnalyticsReportRoleScope.Manager]: t('laManager'),
      [AnalyticsReportRoleScope.AltManager]: t('laAltManager'),
      [AnalyticsReportRoleScope.DeputyManager]: t('laDeputyManager'),
    };

    return {
      typeLabels,
      roleLabels,
    };
  }, [t]);

  const getTypeLabel = useCallback(
    (type: AnalyticsReportTypes) => {
      return typeLabels[type];
    },
    [typeLabels],
  );

  const getRoleLabel = useCallback(
    (role: AnalyticsReportRoleScope) => {
      return roleLabels[role];
    },
    [roleLabels],
  );

  return {
    typeLabels,
    roleLabels,
    getTypeLabel,
    getRoleLabel,
  };
};
